import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import toastMessageListStore from '../../../../../components/toast-messages-modal/toast-messages-store';
import { TOAST_VARIANTS } from '../../../../../components/toast-messages-modal/toast-message/toast-message';
import pageUrlCoordinatorStore from '../../../../../components/layouts/app-layout/page-url-broadcaster/page-url-coordination-store';

const PLAN_APPROVED_PARAM = 'planApproved';

export const usePlanApprovalSuccessToast = (): void => {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const hasHandledRef = useRef(false);

    useEffect(() => {
        if (hasHandledRef.current || searchParams.get(PLAN_APPROVED_PARAM) !== '1') {
            return;
        }

        hasHandledRef.current = true;

        const updatedSearchParams = new URLSearchParams(searchParams);
        updatedSearchParams.delete(PLAN_APPROVED_PARAM);
        setSearchParams(updatedSearchParams, { replace: true });
        pageUrlCoordinatorStore.changeParentPath(location.pathname, updatedSearchParams);

        toastMessageListStore.add({
            title: 'Plan approved successfully',
            description: 'You\'re all set — ReturnGO is ready to use.',
            variant: TOAST_VARIANTS.SUCCESS,
            hasCloseButton: true,
        });
    }, [location.pathname, searchParams, setSearchParams]);
};
